import React from 'react';
import PropTypes from 'prop-types';
import { Box, Text } from '../../../shared/components';
import TwoColumnsFlexLayout from '../../../shared/components/layout/TwoColumnsFlex.layout';
import NumberFormat from '../../../shared/components/dataDisplay/NumberFormat';
import ArticuloImagenLoader from './ArticuloImagenLoader.datadisplay';


const ArticuloFotoGridLine = ({
  articulo,
  articulo: {
    id: articuloId, pvp: precio, descripcion: nombre, codigo,
    stock_tienda_actual: stock,
  }, onClick, selected,
}) => {
  let unidades = null;

  if (stock) {
    unidades = stock.unidades_propias;
  }
  return (
    <Box
      onClick={() => onClick({ articuloId, nombre, precio })}
      style={{
        width: '100%',
      }}
    >
      <TwoColumnsFlexLayout
        style={{
          height: '45px',
          overflow: 'hidden',
        }}
        flexLeft={3}
        leftContent={(
          <Box className="gioweb2-buscador-articulos-grid-line">
            <Text
              style={{
                maxWidth: '90%',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              }}
              display="block"
              color={(selected) ? 'primary' : 'black'}
            >
              {nombre}
            </Text>
            <Text
              mt="8"
              fontSize="12"
              style={{
                maxWidth: '90%',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              }}
              color={(selected) ? 'primary' : 'gray'}
              display="block"
            >
              {codigo}
            </Text>
          </Box>
        )}
        rightContent={(
          <TwoColumnsFlexLayout
            height={{ height: '100%' }}
            flexLeft={3}
            // leftContent={(
            //   <Box
            //     mr="8"
            //     style={{
            //       maxWidth: '98px',
            //       width: 'auto',
            //       height: 'auto',
            //       float: 'right',
            //     }}
            //   >
            //     <ArticuloImagenLoader articulo={articulo} />
            //   </Box>
            // )}
            rightContent={(
              <Box style={{ textAlign: 'right' }}>
                <NumberFormat fontWeight="semibold" number={precio} />
                <Text
                  mt="8"
                  fontSize="12"
                  color="primary"
                  display="block"
                >
                  {unidades}
                  {' '}
                  ud.
                </Text>
              </Box>
            )}
          />
        )}
      />
    </Box>
  );
};

ArticuloFotoGridLine.propTypes = {
  articulo: PropTypes.any,
  photoSrc: PropTypes.string,
  onClick: PropTypes.func,
  selected: PropTypes.bool,
};

ArticuloFotoGridLine.defaultProps = {
  precio: undefined,
  photoSrc: undefined,
  id: undefined,
};

export default ArticuloFotoGridLine;
